module.exports = __webpack_public_path__ + "img/fondo-login.ec7ad4d8.jpg";